const HowToBuymeacoffee = ({ dialogRef, closeDialog, selectedPlan }) => {
  return (
    <dialog
      ref={dialogRef}
      className='w-full max-w-lg max-h-full p-4'
    >
      <div className='flex flex-col'>
        <div className='flex items-center justify-between mb-4'>
          <h1 className='font-bold'>How to subscribe with Buymeacoffee</h1>
          <button
            className='text-xl text-black'
            onClick={closeDialog}
          >
            🅧
          </button>
        </div>
        <button
          className='bg-accent text-black px-4 py-2 rounded-full font-bold mb-4'
          onClick={() => {
            if (selectedPlan) {
              window.open(selectedPlan.link, '_blank');
            }
          }}
        >
          Subscribe Now
        </button>
        <p className='text-sm text-gray-500 mb-2'>Screenshot guide</p>
        <div className='flex gap-4 snap-x overflow-x-scroll scrollbar-hidden snap-mandatory'>
          <div className='snap-always snap-start w-11/12 shrink-0 rounded-xl border-4 border-black flex justify-center items-center'>
            <img
              src='https://static-resource.thechamps.app/img/tutorial/buymeacoffee-premium-1.png'
              alt='Buy me a coffee'
              className='rounded-xl h-full object-contain'
            />
          </div>
          <div className='snap-always snap-start w-11/12 shrink-0 rounded-xl border-4 border-black flex justify-center items-center'>
            <img
              src='https://static-resource.thechamps.app/img/tutorial/buymeacoffee-premium-2.png'
              alt='Buy me a coffee'
              className='rounded-xl h-full object-contain'
            />
          </div>
          <div className='snap-always snap-start w-11/12 shrink-0 rounded-xl border-4 border-black flex justify-center items-center'>
            <img
              src='https://static-resource.thechamps.app/img/tutorial/buymeacoffee-premium-3.png'
              alt='Buy me a coffee'
              className='rounded-xl h-full object-contain'
            />
          </div>
          <div className='snap-always snap-start w-11/12 shrink-0 rounded-xl border-4 border-black flex justify-center items-center'>
            <img
              src='https://static-resource.thechamps.app/img/tutorial/buymeacoffee-premium-4.png'
              alt='Buy me a coffee'
              className='rounded-xl h-full object-contain'
            />
          </div>
        </div>
      </div>
    </dialog>
  );
};

export default HowToBuymeacoffee;
